import React from "react";
import { Navigate } from "react-router-dom";
import { UploadContextProvider as UploadProvider } from "../context/UploadProductContext";

const Protected = ({ children, isAllowed, redirectPath }) => {
  if (!isAllowed) {
    return <Navigate to={redirectPath ?? "/403"} replace />;
  }

  return <UploadProvider>{children}</UploadProvider>;
};

export default Protected;
